enum HomePageFilter {
  typeDeVoyage = 'Type de voyage',
  destination = 'Destination',
  startDate = 'Date de départ',
  from = 'Ville de départ',
  duration = 'Durée',
  flightDate = 'Date de vol',
}
export default HomePageFilter;
